<template lang="html">
	<div
		class="omapi-card-setting-section"
		:class="{'disabled': !connected || !apiKeyValid}"
	>
		<header>
			<h3>
				Easy Digital Downloads
			</h3>
		</header>

		<transition name="fade" mode="out-in">
			<div v-if="!eddLoading && eddVersion && eddVersion.isMinimum === false">
				<core-alert
					type="error"
				>
					The EDD plugin version installed is lower than the minimum required version. Your version is <strong>{{ eddVersion.current }}</strong> and the minimum required is <strong>{{ eddVersion.minimum }}</strong>.
				</core-alert>
			</div>

			<form v-else @submit.prevent="connectOrDisconnect">
				<template v-if="!isEddConnected">
					<p>
						In order to integrate Easy Digital Downloads with our Display Rules, OptinMonster needs <a :href="$urls.wp('wp-admin/edit.php?post_type=download&page=edd-tools&tab=api_keys', 'edit')">EDD REST API credentials</a>.
					</p>

					<core-alert
						v-if="requestFail"
						:closes="true"
						type="error"
					>
						EDD REST API keys could not be auto-generated on your behalf. Please try creating them manually and entering them here.
					</core-alert>

					<div v-if="showEddSettings" class="omapi-flex">
						<div class="omapi-flex-child omapi-input-wrap">
							<label>Public Key:</label>
							<input
								type="password"
								class="omapi-input"
								v-model="publicKey"
								placeholder="Enter your public key here..."
							/>
						</div>
						<div class="omapi-flex-child omapi-input-wrap">
							<label>Token:</label>

							<input
								type="password"
								class="omapi-input"
								v-model="token"
								placeholder="Enter your token here..."
							/>
						</div>
					</div>

					<core-save-button v-bind="buttonAttrs">
						{{ showEddSettings ? 'Connect Easy Digital Downloads' : 'Auto-Generate Keys + Connect Easy Digital Downloads' }}
					</core-save-button>

					<span v-if="showEddSettings && ! eddLoading">or <a href="#" @click.prevent="hideEddSettingsAndAutogenerate">autogenerate and connect</a>.</span>

					<p v-if="!showEddSettings && !eddLoading">
						or <a href="#" @click.prevent="toggleShowEddSettings">click here</a> to enter the public key and token pair manually.
					</p>

				</template>

				<template v-else>
					<core-alert
						type="success"
						icon="success"
						class="omapi-settings-page__plugin-connected"
					>
						<div class="alert-message">
							Easy Digital Downloads is currently connected to OptinMonster{{ eddKey ? ` with the following public key: ${eddKey}&hellip;` : '!'}}
						</div>
					</core-alert>

					<p>To remove your keys from OptinMonster, or to change the public key/token pair associated with OptinMonster, you need to disconnect Easy Digital Downloads, below.</p>

					<core-save-button v-bind="buttonAttrs">
						Disconnect Easy Digital Downloads
					</core-save-button>
				</template>
			</form>
		</transition>
	</div>
</template>

<script lang="js">
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
	data () {
		return {
			showEddSettings : false,
			requestFail     : false,
			publicKey       : '',
			token           : '',
		}
	},
	computed : {
		...mapState([ 'error', 'apiKeyValid' ]),
		...mapGetters([ 'connected', 'showProUpsells', 'userPlanName', 'isLoading' ]),
		...mapGetters('wp', [ 'isEddConnected', 'eddKey', 'eddToken', 'eddVersion' ]),
		eddLoading () {
			return this.isLoading('eddconnect')
		},
		buttonAttrs () {
			let disabled = this.eddLoading || !this.connected || !this.apiKeyValid

			// If we're showing the inputs, then validate if both are filled in.
			if (this.showEddSettings) {
				disabled = disabled || !this.publicKey || !this.token
			}

			return {
				size     : 'large',
				color    : this.eddLoading ? '' : 'blue',
				style    : { marginBottom: '10px' },
				disabled : disabled,
				saving   : this.eddLoading,
				failed   : this.requestFail,
			}
		},
	},
	watch : {
		isEddConnected (val) {
			this.requestFail = false
		},
		error (val) {
			if (!val) {
				this.requestFail = false
			}
		},
	},
	mounted () {
		this.autoFetchEddSettings()
	},
	methods : {
		...mapActions('wp', [ 'autogenerateEddCreds', 'saveEddCreds', 'fetchEddSettings', 'disconnectEdd' ]),
		toggleShowEddSettings () {
			this.showEddSettings = !this.showEddSettings
		},
		hideEddSettingsAndAutogenerate () {
			this.showEddSettings = false
			this.connectOrDisconnect()
		},
		async connectOrDisconnect () {
			this.$store.commit('clearAlerts')
			this.requestFail = false

			// If we're already connected, then it should try disconnecting.
			if (this.isEddConnected) {
				return this.disconnectEdd()
			}

			// If we're using the inputs / manual mode, then save the creds manually.
			if (this.showEddSettings) {
				try {
					await this.saveEddCreds({
						publicKey : this.publicKey,
						token     : this.token,
					})

					this.publicKey = ''
					this.token = ''
				} catch (e) {}

				return
			}

			// Otherwise, autogenerate.
			this.autogenerateEddCreds()
				.catch(e => {
					this.showEddSettings = true
					this.requestFail = true
				})
		},
		autoFetchEddSettings () {
			if (this.isEddConnected && !this.eddKey) {
				this.fetchEddSettings().catch(e => {})
			}
		},
	},
}
</script>
